import { ShoppingCart } from "react-feather";

import useStore from "@store/index";
import { encryptData } from "_services/common.service";

import styles from "@/styles/menu.module.scss";
import Link from "next/link";
import { event } from "@lib/ga";

export const CartLink: React.FC<{ totalCount: number }> = ({ totalCount }) => {
    const { cart, hasHydrated } = useStore();

    // const [isOnload, setIsOnload] =  useState(true);

    const cardId = (cart && cart.orderId && cart.orderId !== "" ? "?c=" + encryptData(cart.orderId) : "");

    const showingCount = (cart && (cart?.lineItems || []).length > 0 ? (totalCount > 0? totalCount: (cart?.lineItems?.reduce((total, item) => total + (parseInt(item.quantity.toString() || '0')), 0) || 0)) : 0);
   
    if (!hasHydrated) {
        return null;
    }

    return (
        <Link href={"/cart"+ cardId} onClick={() => {
            event({
                action: 'navigate_cart',
                category: 'engagement',
                label: 'navbar_cart_clicked'
            })
        }} className={styles.cartLink} replace id="nav-cart-link">
            <div className={styles.cartLinkIcon}>
                <ShoppingCart size={20} />
                {showingCount > 0 && <span className={styles.cartCount}>{showingCount}</span>}
            </div>
        </Link>
    );
}
